/**
 * Where to go after signing in, registering or confirming an email, when a page
 * sent the reader off to do one of those first (the cohort invitation page does).
 *
 * localStorage rather than sessionStorage: the confirmation link in the email
 * usually opens in a new tab. Kept as long as an emailed invitation lasts, and
 * used once.
 */
const KEY = "divecohorts_return_to";
const MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000;

export function rememberReturn(path) {
  localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
}

/** The remembered path (forgotten once read), or `fallback`. */
export function takeReturn(fallback) {
  const raw = localStorage.getItem(KEY);
  localStorage.removeItem(KEY);
  try {
    const { path, at } = JSON.parse(raw);
    // An in-app path only: never somewhere off this site.
    if (typeof path === "string" && path.startsWith("/") && !path.startsWith("//") && Date.now() - at < MAX_AGE_MS) {
      return path;
    }
  } catch {
    // Missing or malformed: the usual destination.
  }
  return fallback;
}
